var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    enableBackground: "new 0 0 30 30",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-cross",
    fill: "#FF4343",
    d: "M24.941,21.144L24.941,21.144l-6.145-6.143l6.145-6.143l0,0 c0.244-0.249,0.244-0.646,0-0.894l-2.904-2.905c-0.248-0.246-0.646-0.246-0.895,0l0,0l-6.146,6.147L8.854,5.063l0,0 c-0.249-0.246-0.647-0.246-0.894,0l-2.901,2.9c-0.246,0.248-0.246,0.645,0,0.894l0,0L11.202,15l-6.143,6.144l0,0 c-0.246,0.249-0.246,0.646,0,0.894l2.906,2.904c0.248,0.245,0.645,0.245,0.894,0l0,0l6.143-6.143l6.143,6.143l0,0 c0.249,0.245,0.647,0.245,0.895,0l2.904-2.904C25.188,21.789,25.188,21.392,24.941,21.144L24.941,21.144z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.adf33e98b88b8856f9f4378dd035e7f1.svg";
export { ForwardRef as ReactComponent };